<div class="container">
    <div class="card">
        <div class="card-body">
            <form [formGroup]="form">

                <!-- Business Details Section -->

                <div class="card">
                    <div formGroupName="ficaDetails">
                        <div class="card-header">
                            <h2 class="orange-border">Business Details
                                <a [ngClass]="{
                                        'fa-check-circle': !hasFailedKyc && !isKycPending,
                                        'fa-exclamation-circle': isKycPending,
                                        'fa-times-circle': hasFailedKyc
                                    }" [ngStyle]="{
                                        'color': !hasFailedKyc && !isKycPending? 'green' : hasFailedKyc ? 'red': 'orange'
                                    }" class="fa" pTooltip="{{getKycStatusToolTip()}}"></a>
                            </h2>
                        </div>
                        <div class="card-body">

                            <div class="row">
                                <div class="form-group col-md-6">
                                    <label for="businessName">Business Name:</label>
                                    <input [ngClass]="{ 'is-invalid': displayError(ficaDetails.businessName)}"
                                           class="form-control"
                                           formControlName="businessName"
                                           id="businessName"
                                           pTooltip="The legal name of your business"
                                           type="text"/>@if (displayError(ficaDetails.businessName)) {
                                    <div class="invalid-feedback">
                                        @if (ficaDetails.businessName.errors.required) {
                                            <div>Business name is required.
                                            </div>
                                        }
                                        @if (ficaDetails.businessName.errors.duplicateBusinessName) {
                                            <div>
                                                The business name already exists.
                                            </div>
                                        }
                                        @if (ficaDetails.businessName.errors.maxlength) {
                                            <div>Business name cannot exceed 255 characters.
                                            </div>
                                        }
                                    </div>
                                }
                                </div>
                                <div class="form-group col-md-6">
                                    <label for="businessType">Business Type:</label>
                                    <p-select (onChange)="refreshIsSoleProprietor()"
                                              [options]="businessTypeList"
                                              class="form-control"
                                              formControlName="businessType"
                                              id="businessType"
                                              optionLabel="label"
                                              optionValue="value"
                                              placeholder="Select your business type"/>
                                </div>
                            </div>

                            <div class="row">
                                <div class="form-group col-md-6">
                                    <label for="nature-of-business">Nature of Business:</label>
                                    <p-select [options]="natureOfBusinessList"
                                              class="form-control"
                                              formControlName="natureOfBusiness"
                                              id="nature-of-business"
                                              optionLabel="name"
                                              optionValue="name"
                                              placeholder="-- Please select --"/>
                                    @if (displayError(ficaDetails.natureOfBusiness)) {
                                        <div class="form-input-error">
                                            @if (ficaDetails.natureOfBusiness.errors.required || ficaDetails.natureOfBusiness.errors.nullValidator) {
                                                <div>
                                                    Nature of business is required.
                                                </div>
                                            }
                                        </div>
                                    }
                                </div>

                                @if (otherNatureOfBusinessSelected) {
                                    <div class="form-group col-md-6">
                                        <label for="natureOfBusinessOther">Please Specify (Nature of Business):</label>
                                        <input [ngClass]="{ 'is-invalid': displayError(ficaDetails.natureOfBusinessOther) }"
                                               class="form-control"
                                               formControlName="natureOfBusinessOther"
                                               id="natureOfBusinessOther"
                                               placeholder=""
                                               type="text"/>@if (displayError(ficaDetails.natureOfBusinessOther)) {
                                        <div class="form-input-error">
                                            @if (ficaDetails.natureOfBusinessOther.errors.required) {
                                                <div>
                                                    Nature of business is required.
                                                </div>
                                            }
                                            @if (ficaDetails.natureOfBusinessOther.errors.maxlength) {
                                                <div>
                                                    Nature of business is limited to a maximum length of 400 characters
                                                </div>
                                            }
                                        </div>
                                    }
                                    </div>
                                }
                            </div>

                            <div class="row">
                                <div class="form-group col-md-6">
                                    <label for="fspNumber">FSP Number:</label>
                                    <input [ngClass]="{ 'is-invalid': displayError(ficaDetails.fspNumber)}"
                                           class="form-control"
                                           formControlName="fspNumber"
                                           id="fspNumber"
                                           type="text"/>@if (displayError(ficaDetails.fspNumber)) {
                                    <div class="form-input-error">
                                        @if (ficaDetails.fspNumber.errors.required) {
                                            <div>FSP number is required</div>
                                        }
                                        @if (ficaDetails.fspNumber.errors.validateFSPNumber) {
                                            <div>
                                                FSP number must consist of digits from 0 to 9
                                            </div>
                                        }
                                    </div>
                                }
                                </div>
                                <div [hidden]="isSoleProprietor" class="form-group col-md-6">
                                    <validation [formGroup]="$any(form.get('ficaDetails'))"
                                                controlName="registrationNumber"
                                                displayName="Business registration number">
                                        <label for="registrationNumber">Business Registration Number:</label> <input
                                            class="form-control"
                                            formControlName="registrationNumber"
                                            id="registrationNumber"
                                            normaliseRegistrationNumber
                                            type="text"/>
                                    </validation>
                                </div>
                            </div>

                            <div class="row">
                                <div class="form-group col-md-6">
                                    <label for="vatNumber">VAT Number:</label> <input class="form-control"
                                                                                      formControlName="vatNumber"
                                                                                      id="vatNumber"
                                                                                      pTooltip="Enter VAT number or leave empty if non-VAT"
                                                                                      placeholder="non-VAT"
                                                                                      type="text"/>@if (displayError(ficaDetails.vatNumber)) {
                                    <div class="invalid-feedback">
                                        @if (ficaDetails.vatNumber.value.length > 0) {
                                            <div>
                                                VAT registered
                                            </div>
                                        }
                                        @if (ficaDetails.vatNumber.value.length == 0) {
                                            <div>
                                                Non-VAT registered
                                            </div>
                                        }
                                    </div>
                                }
                                </div>
                            </div>

                            <div class="row">
                                <div class="form-group col-md-4">
                                    <label for="directorIdNumber">Director ID Number:</label>
                                    <input [ngClass]="{ 'is-invalid': displayError(ficaDetails.directorIdNumber)}"
                                           class="form-control"
                                           formControlName="directorIdNumber"
                                           id="directorIdNumber"
                                           type="text"/>
                                    @if (displayError(ficaDetails.directorIdNumber)) {
                                        <div class="invalid-feedback">
                                            @if (ficaDetails.directorIdNumber.errors.required) {
                                                <div>Director ID number is required
                                                </div>
                                            }
                                            @if (ficaDetails.directorIdNumber.errors.invalidIdLength) {
                                                <div>ID number must be 13 characters and numeric
                                                </div>
                                            }
                                            @if (ficaDetails.directorIdNumber.errors.invalidIdNumber) {
                                                <div>ID number must be a valid SA ID number
                                                </div>
                                            }
                                        </div>
                                    }
                                </div>


                                <div class="form-group col-md-4">
                                    <label for="directorName">Director First Name:</label>
                                    <input [ngClass]="{ 'is-invalid': displayError(ficaDetails.directorName)}"
                                           class="form-control"
                                           formControlName="directorName"
                                           id="directorName"
                                           type="text"/>@if (displayError(ficaDetails.directorName)) {
                                    <div class="invalid-feedback">
                                        @if (ficaDetails.directorName.errors.required) {
                                            <div>Owner name is required
                                            </div>
                                        }
                                    </div>
                                }
                                </div>

                                <div class="form-group col-md-4">
                                    <label for="directorSurname">Director Surname:</label>
                                    <input [ngClass]="{ 'is-invalid': displayError(ficaDetails.directorSurname)}"
                                           class="form-control"
                                           formControlName="directorSurname"
                                           id="directorSurname"
                                           type="text"/>@if (displayError(ficaDetails.directorSurname)) {
                                    <div class="invalid-feedback">
                                        @if (ficaDetails.directorSurname.errors.required) {
                                            <div>Owner surname is required
                                            </div>
                                        }
                                    </div>
                                }
                                </div>
                            </div>

                            <div class="row">
                                <div class="form-group col-md-12">
                                    <label for="websiteUrl">Website URL:</label>
                                    <input [ngClass]="{ 'is-invalid': displayError(ficaDetails.websiteUrl)}"
                                           class="form-control"
                                           formControlName="websiteUrl"
                                           id="websiteUrl"
                                           pTooltip="Website URL for the business"
                                           type="text"/>@if (displayError(ficaDetails.websiteUrl)) {
                                    <div class="invalid-feedback">
                                        @if (ficaDetails.websiteUrl.errors.maxlength) {
                                            <div>
                                                Website URL limited to a maximum length of 100 characters
                                            </div>
                                        }
                                    </div>
                                }
                                </div>
                            </div>

                            <div class="row">
                                <div class="form-group col-md-12">
                                    <label for="overview">Tell us what your business does:</label>
                                    <textarea [ngClass]="{ 'is-invalid': displayError(ficaDetails.overview)}"
                                              class="form-control"
                                              cols="2"
                                              formControlName="overview"
                                              id="overview"
                                              pTooltip="Business overview (i.e detailed business overview and related information)"
                                              rows="3"
                                              type="text"></textarea>@if (displayError(ficaDetails.overview)) {
                                    <div class="invalid-feedback">
                                        @if (ficaDetails.overview.errors.required) {
                                            <div>
                                                Business overview is required
                                            </div>
                                        }
                                        @if (ficaDetails.overview.errors.maxlength) {
                                            <div>
                                                Overview limited to a maximum length of 250 characters
                                            </div>
                                        }
                                    </div>
                                }
                                </div>
                            </div>

                        </div>
                    </div>
                    <div formGroupName="businessDetails">
                        <!-- Address Section -->

                        <div class="card-header"><h2 class="orange-border">Address</h2></div>
                        <div class="card-body" formGroupName="address">

                            <div class="row">
                                <div class="form-group col-md-12">
                                    <label for="address1">Address Line 1:</label> <input class="form-control"
                                                                                         formControlName="address1"
                                                                                         id="address1"
                                                                                         type="text"/>
                                </div>

                                <div class="form-group col-md-12">
                                    <label for="address2">Address Line 2:</label> <input class="form-control"
                                                                                         formControlName="address2"
                                                                                         id="address2"
                                                                                         type="text"/>
                                </div>

                                <div class="form-group col-md-4">
                                    <label for="city">Town / City:</label> <input class="form-control"
                                                                                  formControlName="city"
                                                                                  id="city"
                                                                                  type="text"/>
                                </div>

                                <div class="form-group col-md-4">
                                    <label for="province"> Province / State:</label>
                                    <p-select [options]="provinceList"
                                              class="form-control"
                                              formControlName="province"
                                              id="province"
                                              optionLabel="value"
                                              optionValue="value"></p-select>
                                </div>

                                <div class="form-group col-md-4">
                                    <label for="postalCode">Postal Code:</label> <input class="form-control"
                                                                                        formControlName="postalCode"
                                                                                        id="postalCode"
                                                                                        type="text"/>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>

                <!-- Banking Details -->

                <div class="card">
                    <div class="card-header">
                        <h2 class="orange-border">Banking Details
                            <a [ngClass]="{
                                'fa-check-circle': isBankDetailsVerified(),
                                'fa-exclamation-circle': isBankDetailsPending() || isBankDetailsEmpty(),
                                'fa-times-circle': isBankDetailsFailed()
                            }" [ngStyle]="{
                                'color': isBankDetailsVerified() ? 'green' :
                                    isBankDetailsPending() || isBankDetailsEmpty() ? 'orange' : 'red'
                           }" class="fa" pTooltip="{{getBankDetailsToolTip()}}"></a>
                        </h2>
                    </div>
                    <div class="card-body" formGroupName="bankDetails">

                        <div class="row">
                            <div class="form-group col-md-4">
                                <label for="bankName">Bank Name:</label>
                                <p-select (onChange)="updateBank()"
                                          [options]="banks"
                                          class="form-control"
                                          formControlName="bankName"
                                          id="bankName"
                                          optionLabel="bankName"
                                          optionValue="bankName"
                                          placeholder="Select your bank"/>
                                @if (displayError(bankDetails.bankName)) {
                                    <div class="invalid-feedback">
                                        @if (bankDetails.bankName.errors.required) {
                                            <div>Bank is required</div>
                                        }
                                    </div>
                                }
                            </div>

                            <div class="form-group  col-md-4">
                                <label for="bankAccountNumber">Account Number:</label>
                                <input [ngClass]="{ 'is-invalid': displayError(bankDetails.bankAccountNumber)}"
                                       class="form-control"
                                       formControlName="bankAccountNumber"
                                       id="bankAccountNumber"
                                       mask="0*"
                                       maxlength="30"
                                       pTooltip="Any updates to your bank
                                       account number will require an account verification (AVS) check to be completed."
                                       type="text"/>@if (displayError(bankDetails.bankAccountNumber)) {
                                <div class="invalid-feedback">
                                    @if (bankDetails.bankAccountNumber.errors.required) {
                                        <div>Account number is required
                                        </div>
                                    }
                                </div>
                            }
                            </div>

                            <div class="form-group col-md-4">
                                <label for="bankBranch">Branch:</label>
                                <input [ngClass]="{ 'is-invalid': displayError(bankDetails.bankBranch)}"
                                       class="form-control"
                                       formControlName="bankBranch"
                                       id="bankBranch"
                                       mask="0*"
                                       maxlength="10"
                                       pTooltip="The bank branch number.
                                       Will be automatically populated with the universal branch number of the bank chosen"
                                       type="text"/>@if (displayError(bankDetails.bankBranch)) {
                                <div class="invalid-feedback">
                                    @if (bankDetails.bankBranch.errors.required) {
                                        <div>Branch number is required</div>
                                    }
                                </div>
                            }
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Profile Section -->
                @if (!hideOnboardingSections) {
                <div class="card">
                    <div class="card-header"><h2 class="orange-border">Invoice Profile View</h2></div>
                    <div class="card-body" formGroupName="businessDetails">

                        <div class="row">
                            <div class="form-group col-md-4">
                                <label for="contactNumber">Business Contact Number:</label>
                                <input [ngClass]="{ 'is-invalid': displayError(businessDetails.contactNumber)}"
                                       [showMaskTyped]="true"
                                       class="form-control"
                                       formControlName="contactNumber"
                                       id="contactNumber"
                                       mask="000-000-0000"
                                       pTooltip="Call center or help line number"
                                       type="text"/>@if (displayError(businessDetails.contactNumber)) {
                                <div class="invalid-feedback">
                                    @if (businessDetails.contactNumber.errors.required) {
                                        <div>Contact number is required
                                        </div>
                                    }
                                    @if (businessDetails.contactNumber.errors.pattern) {
                                        <div>
                                            Invalid contact number, expected format is 123-123-1234
                                        </div>
                                    }
                                </div>
                            }
                            </div>

                            <div class="form-group col-md-4">
                                <label for="displayName">Display Name:</label>
                                <input [ngClass]="{ 'is-invalid': displayError(businessDetails.displayName)}"
                                       class="form-control"
                                       formControlName="displayName"
                                       id="displayName"
                                       pTooltip="Business trading name, this will be displayed on invoices"
                                       type="text"/>@if (displayError(businessDetails.displayName)) {
                                <div class="invalid-feedback">
                                    @if (businessDetails.displayName.errors.required) {
                                        <div>Business display name is required
                                        </div>
                                    }
                                    @if (businessDetails.displayName.errors.maxlength) {
                                        <div>Business display name allows a maximum of 30 characters
                                        </div>
                                    }
                                </div>
                            }
                            </div>

                            <div class="form-group col-md-4">
                                <label for="email">Business Contact Email:</label>
                                <input [ngClass]="{ 'is-invalid': displayError(businessDetails.contactEmail)}"
                                       class="form-control"
                                       formControlName="contactEmail"
                                       id="email"
                                       pTooltip="Business email address, this will be displayed on invoices"
                                       type="email"/>@if (displayError(businessDetails.contactEmail)) {
                                <div class="invalid-feedback">
                                    @if (businessDetails.contactEmail.errors.required) {
                                        <div>Email is required</div>
                                    }
                                    @if (businessDetails.contactEmail.errors.email) {
                                        <div>Invalid email</div>
                                    }
                                </div>
                            }
                            </div>
                        </div>
                        <div class="row">
                            <div class="form-group col-md-4">
                                <label for="isGlobalSendInvoice">Auto-Generate Invoice (Default): </label>
                                <a class="pi pi-question-circle tooltip-icon tooltip-spacing-left" pTooltip="If enabled, will automatically generate and attach
                                        an invoice to all request to pay transactions sent out to clients. This setting
                                        can be overridden for each individual request to pay transaction sent."></a>
                                <div class="form-inline">
                                    <p-toggleswitch [readonly]="isSpecialMerchant"
                                                    formControlName="sendInvoice"
                                                    id="isGlobalSendInvoice"></p-toggleswitch>
                                    <h4 class="margin-toggle">{{ isInvoiceEnabled() }}</h4>
                                </div>
                            </div>
                            <div class="form-group col-md-4">
                                <label for="customRefEnabled">Custom Account/Reference Number Enabled: </label>
                                <a class="pi pi-question-circle tooltip-icon tooltip-spacing-left" pTooltip="If enabled, this will allow you to choose your own account number that
                                will be associated with a request to pay transaction. This will allow you to keep track
                                of request to pay transactions associated with particular clients."></a>
                                <div class="form-inline">
                                    <p-toggleswitch (onChange)="confirmCustomRefEnabledChange()"
                                                    [readonly]="isSpecialMerchant"
                                                    formControlName="customRefEnabled"
                                                    id="customRefEnabled"></p-toggleswitch>
                                    <h4 class="margin-toggle">{{ isCustomRefEnabled() }}</h4>
                                </div>
                            </div>
                            <div class="form-group col-md-4">
                                <label for="multiPremiumEnabled">Multi Premium Payments Enabled: </label>
                                <a class="pi pi-question-circle tooltip-icon tooltip-spacing-left" pTooltip="If enabled, this will allow customers to pay this request in multiples of
                                    the original amount. For example, if the request is R30 and the multi premium option
                                     allowed is 3, customers can pay R30, R60, or R90."></a>
                                <div class="form-inline">
                                    <p-toggleswitch formControlName="multiPremiumEnabled"
                                                    id="multiPremiumEnabled"></p-toggleswitch>
                                    <h4 class="margin-toggle">{{ multiPremiumEnabledLabel() }}</h4>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            @if (ficaDetails?.vatNumber?.value?.length > 0) {
                                <div class="form-group col-md-4">
                                    <label for="useVatInclusiveAmount">VAT Inclusive Amount: </label>
                                    <a class="pi pi-question-circle tooltip-icon tooltip-spacing-left" pTooltip="If enabled, request to pay amounts will not calculate & add VAT.
                                    If disabled, VAT will be calculated & added to request to pay amounts"></a>
                                    <div class="form-inline">
                                        <p-toggleswitch formControlName="useVatInclusiveAmount"
                                                        id="useVatInclusiveAmount"></p-toggleswitch>
                                        <h4 class="margin-toggle">{{ useVatInclusiveAmountLabel() }}</h4>
                                    </div>
                                </div>
                            }
                        </div>
                        <div class="row align-items-center">
                            <div class="form-group col-md-6">
                                <label for="companyLogo">Company Logo:</label>
                                <div class="custom-file">
                                    <input (change)="loadAndValidateLogo($event)"
                                           accept="image/*"
                                           class="form-control custom-file-input"
                                           id="companyLogo"
                                           pTooltip="Supported image formats are .png and .jpg. The file size may
                                               not exceed 512 KB."
                                           type="file"/> <label class="custom-file-label"
                                                                for="companyLogo"> {{ getLogoFileName() }} </label>
                                </div>
                            </div>
                            <div class="form-group input-group col-md-6">
                                <div [hidden]="!logoImage" class="company-logo-upload-border">
                                    <div class="company-logo-upload">
                                        <img [src]="logoImage" alt="logo" id="company-logo-image" width="100%">
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="form-group col-md-12">
                                <label for="disclaimer">Business Invoice Disclaimer:</label>
                                <textarea [ngClass]="{ 'is-invalid': displayError(businessDetails.disclaimer)}"
                                          class="form-control"
                                          cols="2"
                                          formControlName="disclaimer"
                                          id="disclaimer"
                                          pTooltip="Business disclaimer, this will be displayed on invoices"
                                          rows="5"
                                          type="text"></textarea>@if (displayError(businessDetails.disclaimer)) {
                                <div class="invalid-feedback">
                                    @if (businessDetails.disclaimer.errors.maxlength) {
                                        <div>
                                            Disclaimers are limited to a maximum length of 1000 characters
                                        </div>
                                    }
                                </div>
                            }
                            </div>
                        </div>
                    </div>
                </div>
                }
                <div class="card">
                    <div class="card-header"><h2 class="orange-border">Billing Information</h2></div>
                    <div class="card-body" formGroupName="businessDetails">
                        <div class="row">
                            <div class="form-group col-md-4">
                                <label for="billing-email">Billing Email:</label>
                                <input [ngClass]="{ 'is-invalid': displayError(businessDetails.billingEmail)}"
                                       class="form-control"
                                       formControlName="billingEmail"
                                       id="billing-email"
                                       pTooltip="Billing email address, this will be used to receive invoices"
                                       type="email"/>@if (displayError(businessDetails.billingEmail)) {
                                <div class="invalid-feedback">
                                    @if (businessDetails.billingEmail.errors.required) {
                                        <div>Email is required</div>
                                    }
                                    @if (businessDetails.billingEmail.errors.email) {
                                        <div>Invalid email</div>
                                    }
                                </div>
                            }
                            </div>
                        </div>
                    </div>
                </div>
                @if (!hideOnboardingSections) {
                <div class="card">
                    <div class="card-header">
                        <h2 class="orange-border">
                            Payment Notification Webhook
                            <a class="pi pi-question-circle tooltip-icon tooltip-spacing-left"
                               pTooltip="Configure a webhook to receive real-time notifications when payment events occur. Test your webhook URL to ensure it can receive notifications."></a>
                        </h2>
                    </div>
                    <div class="card-body">
                        @if (isLoadingWebhooks()) {
                            <div class="text-center py-3">
                                <i class="fa fa-spinner fa-spin fa-2x"></i>
                                <p class="mt-2">Loading webhook...</p>
                            </div>
                        } @else {
                            @if (hasPaymentWebhook()) {
                                <div [formGroup]="webhookForm" class="row">
                                    <div class="form-group col-md-8">
                                        <label>Payment Notification Webhook URL:</label>
                                        @if (isEditingWebhook(paymentWebhook())) {
                                            <validation [formGroup]="webhookForm"
                                                        controlName="url"
                                                        displayName="Webhook URL">
                                                <input class="form-control"
                                                       formControlName="url"
                                                       placeholder="https://your-domain.com/webhook"
                                                       type="text"/>
                                            </validation>
                                        } @else {
                                            <input [value]="paymentWebhook()?.webhookUrl"
                                                   class="form-control"
                                                   disabled
                                                   type="text"/>
                                        }
                                    </div>
                                    <div class="form-group col-md-4 d-flex align-items-center mt-4">
                                        @if (isEditingWebhook(paymentWebhook())) {
                                            <button (click)="updateWebhook(paymentWebhook())"
                                                    [disabled]="isSavingWebhook() || webhookForm.invalid"
                                                    class="navy-btn mr-2 form-control-height text-nowrap"
                                                    type="button">
                                                Save <i [hidden]="!isSavingWebhook()"
                                                        class="fa fa-spinner fa-spin ml-1"></i>
                                            </button>
                                            <button (click)="cancelEditWebhook()"
                                                    [disabled]="isSavingWebhook()"
                                                    class="orange-btn form-control-height"
                                                    type="button">
                                                Cancel
                                            </button>
                                        } @else {
                                            <button (click)="testWebhookUrl(paymentWebhook()?.webhookUrl)"
                                                    [disabled]="isSavingWebhook() || !paymentWebhook()?.webhookUrl"
                                                    class="navy-btn mr-2 form-control-height"
                                                    type="button">
                                                Test <i class="fa fa-play ml-1"></i>
                                            </button>
                                            <button (click)="startEditWebhook(paymentWebhook())"
                                                    [disabled]="isSavingWebhook()"
                                                    class="navy-btn mr-2 form-control-height"
                                                    type="button">
                                                Edit <i class="fa fa-edit ml-1"></i>
                                            </button>
                                            <button (click)="deleteWebhook(paymentWebhook())"
                                                    [disabled]="isSavingWebhook()"
                                                    class="orange-btn text-nowrap form-control-height"
                                                    pTooltip="Permanently remove this webhook"
                                                    type="button">
                                                Delete
                                                <i [ngClass]="isSavingWebhook() ? 'fa fa-spinner fa-spin ml-1' : 'fa fa-trash ml-1'"></i>
                                            </button>
                                        }
                                    </div>
                                </div>
                            } @else if (showAddWebhookForm()) {
                                <div [formGroup]="webhookForm" class="row">
                                    <div class="form-group col-md-8">
                                        <validation [formGroup]="webhookForm"
                                                    controlName="url"
                                                    displayName="Webhook URL">
                                            <label for="newWebhookUrl">Payment Notification Webhook URL:</label> <input
                                                class="form-control"
                                                formControlName="url"
                                                id="newWebhookUrl"
                                                placeholder="https://your-domain.com/webhook"
                                                type="text"/>
                                        </validation>
                                    </div>
                                    <div class="form-group col-md-4 d-flex align-items-center mt-4">
                                        <button (click)="createWebhook()"
                                                [disabled]="isSavingWebhook() || webhookForm.invalid"
                                                class="navy-btn mr-2 form-control-height text-nowrap"
                                                type="button">
                                            Save <i [hidden]="!isSavingWebhook()"
                                                    class="fa fa-spinner fa-spin ml-1"></i>
                                        </button>
                                        <button (click)="cancelAddWebhook()"
                                                [disabled]="isSavingWebhook()"
                                                class="orange-btn form-control-height"
                                                type="button">
                                            Cancel
                                        </button>
                                    </div>
                                </div>
                            } @else {
                                <div class="row">
                                    <div class="form-group col-md-12">
                                        <div class="alert alert-info mb-3">
                                            <i class="fas fa-info-circle"></i> No payment notification webhook
                                            configured.
                                        </div>
                                        <button (click)="showAddWebhook()" class="navy-btn" type="button">
                                            <i class="fa fa-plus mr-1"></i> Add Webhook
                                        </button>
                                    </div>
                                </div>
                            }
                        }
                    </div>
                </div>
                }

                <!-- E-Commerce Config Section -->
                @if (environmentService.eCommerceEnabled && businessDetailsDTO?.eCommerceMerchant && !hideOnboardingSections) {
                    <div id="ecommerce-config" class="card">
                        <div class="card-header">
                            <h2 class="orange-border">
                                E-Commerce Configuration
                                <a class="pi pi-question-circle tooltip-icon tooltip-spacing-left"
                                   pTooltip="E-commerce stores can integrate with our platform to handle payments for online purchases."></a>
                            </h2>
                        </div>
                        <div class="card-body">
                            @if (availableECommerceStores?.length > 0) {
                                @if (canManageECommerceStoreCredentials) {
                                    <div [formGroup]="eCommerceStoreForm" class="ecommerce-add-store">
                                        <div class="ecommerce-add-store-field">
                                            <label for="eCommerceStores">E-Commerce Store:</label>
                                            <p-select [options]="selectableECommerceStores"
                                                      class="ecommerce-add-store-select"
                                                      formControlName="selectedECommerceStore"
                                                      inputId="eCommerceStores"
                                                      optionLabel="storeName"
                                                      placeholder="Select Store"/>
                                        </div>
                                        <div class="ecommerce-add-store-field">
                                            <validation [formGroup]="eCommerceStoreForm"
                                                        controlName="eCommerceStoreDomain"
                                                        displayName="Storefront domain">
                                                <label for="eCommerceStoreDomain">Storefront Domain:</label>
                                                <input class="ecommerce-add-store-input"
                                                       formControlName="eCommerceStoreDomain"
                                                       id="eCommerceStoreDomain"
                                                       maxlength="255"
                                                       placeholder="example.com"
                                                       type="text"/>
                                            </validation>
                                        </div>
                                        <div class="ecommerce-add-store-field">
                                            <validation [formGroup]="eCommerceStoreForm"
                                                        controlName="eCommerceStoreDescription"
                                                        displayName="Description">
                                                <label for="eCommerceStoreDescription">Description (Optional):</label>
                                                <input class="ecommerce-add-store-input"
                                                       formControlName="eCommerceStoreDescription"
                                                       id="eCommerceStoreDescription"
                                                       maxlength="255"
                                                       placeholder="e.g. Main online store"
                                                       type="text"/>
                                            </validation>
                                        </div>
                                        <div class="ecommerce-add-store-field ecommerce-add-store-field--action">
                                            <span aria-hidden="true" class="ecommerce-add-store-label-spacer"></span>
                                            <button (click)="addECommerceStoreToMerchant()"
                                                    [disabled]="!isECommerceStoreSelected || !isECommerceStoreDomainValid || isLoading()"
                                                    class="ecommerce-add-store-btn"
                                                    type="button">
                                                @if (isLoading()) {
                                                    <i class="fa fa-spinner fa-spin"></i>
                                                } @else {
                                                    <i class="fa fa-plus"></i>
                                                }
                                                Add Store
                                            </button>
                                        </div>
                                    </div>
                                    <div class="alert alert-info ecommerce-add-store-note">
                                        <i class="fas fa-info-circle"></i>
                                        Your keys will only work on the domain you enter here.
                                        We check every new store before it can go live, so it cannot take
                                        payments until that check is done.
                                    </div>
                                }
                            } @else {
                                <div class="alert alert-info">
                                    <i class="fas fa-info-circle"></i> No e-commerce stores are currently available.
                                    Please contact support to enable e-commerce store integrations.
                                </div>
                            }
                            @if (businessECommerceStores?.length > 0) {
                                <div class="ecommerce-stores-heading">
                                    <h3 class="ecommerce-stores-title">Stores</h3>
                                    <span class="ecommerce-stores-count">{{ businessECommerceStores.length }} connected</span>
                                </div>
                                <div class="ecommerce-table-container">
                                    <p-table [value]="businessECommerceStores" class="ecommerce-table">
                                        <ng-template #header>
                                            <tr>
                                                <th scope="col">Store</th>
                                                <th scope="col">Description</th>
                                                <th scope="col">Date Created</th>
                                                <th scope="col">Status</th>
                                                <th scope="col">Verification</th>
                                                @if (canManageECommerceStoreCredentials) {
                                                    <th class="ecommerce-actions-cell" scope="col">Actions</th>
                                                }
                                            </tr>
                                        </ng-template>
                                        <ng-template #body let-businessECommerceStore>
                                            <tr>
                                                <td>
                                                    <div class="ecommerce-store-domain">{{ businessECommerceStore?.domain || '-' }}</div>
                                                    <div class="ecommerce-store-type">{{ businessECommerceStore?.eCommerceStoreName }}</div>
                                                </td>
                                                <td>
                                                    <span class="ecommerce-store-description"
                                                          [pTooltip]="businessECommerceStore?.description">
                                                        {{ businessECommerceStore?.description || '-' }}
                                                    </span>
                                                </td>
                                                <td>
                                                    <div>{{ businessECommerceStore?.dateTimeCreated | amFromUtc | amLocal | amDateFormat: 'DD MMM YYYY' }}</div>
                                                    <div class="ecommerce-store-time">{{ businessECommerceStore?.dateTimeCreated | amFromUtc | amLocal | amDateFormat: 'HH:mm' }}</div>
                                                </td>
                                                <td>
                                                    @if (businessECommerceStore?.active) {
                                                        <span class="ecommerce-pill ecommerce-pill--success">
                                                            <span class="ecommerce-pill-dot"></span>Active
                                                        </span>
                                                    } @else {
                                                        <span class="ecommerce-pill ecommerce-pill--neutral">
                                                            <span class="ecommerce-pill-dot"></span>Inactive
                                                        </span>
                                                    }
                                                </td>
                                                <td>
                                                    @let verification = getECommerceStoreVerification(businessECommerceStore);
                                                    <span [class]="'ecommerce-pill ecommerce-pill--' + verification.tone"
                                                          [pTooltip]="verification.detail">
                                                        <i [class]="verification.pillIconClass"></i>{{ verification.label }}
                                                    </span>
                                                </td>
                                                @if (canManageECommerceStoreCredentials) {
                                                    <td class="ecommerce-actions-cell">
                                                        <button (click)="openStoreKeys(businessECommerceStore)"
                                                                class="ecommerce-view-keys-btn"
                                                                type="button">
                                                            <i class="fas fa-key"></i> View Keys
                                                        </button>
                                                    </td>
                                                }
                                            </tr>
                                        </ng-template>
                                    </p-table>
                                </div>
                            } @else if (availableECommerceStores?.length > 0) {
                                <div class="alert alert-info mt-3">
                                    <i class="fas fa-info-circle"></i>
                                    @if (canManageECommerceStoreCredentials) {
                                        You haven't added any e-commerce store integrations yet. Select a store
                                        from the dropdown above to get started.
                                    } @else {
                                        No e-commerce store integrations have been added yet.
                                    }
                                </div>
                            }
                        </div>
                    </div>
                }

                <!-- OAuth Credentials Section -->
                @if (!hideOnboardingSections) {
                <div class="card">
                    <div class="card-header">
                        <h2 class="orange-border">
                            API Credentials
                            <a class="pi pi-question-circle tooltip-icon tooltip-spacing-left"
                               pTooltip="These credentials allow you to securely access Pay@Go's API."></a>
                        </h2>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="form-group col-md-12">
                                @if (hasOAuthCredentials) {
                                    <div class="alert alert-info mt-2">
                                        <i class="fas fa-info-circle"></i> OAuth credentials have already been generated
                                        for this business and can be reset.
                                    </div>
                                }
                                <button (click)="generateOAuthCredentials()"
                                        [hidden]="  hasOAuthCredentials"
                                        class="navy-btn"
                                        type="button">
                                    Generate API Credentials
                                </button>
                                <button (click)="openResetOAuthClientSecretDialog()"
                                        [hidden]="!hasOAuthCredentials"
                                        class="navy-btn">
                                    Reset Client Secret <i [hidden]="!isLoading()"
                                                           class="fa fa-spinner fa-spin"
                                                           pButton
                                                           pRipple></i>
                                </button>
                                <a class="navy-btn ml-2"
                                   [href]="environmentService.swaggerMerchantAPILink"
                                   target="_blank">
                                    API Documentation
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                }

                <!-- Marketing Consent Section -->
                <div class="card">
                    <div class="card-header">
                        <h2 class="orange-border">
                            Marketing Consent
                            <a class="pi pi-question-circle tooltip-icon tooltip-spacing-left"
                               pTooltip="If enabled, you consent to receive additional marketing communications from us."></a>
                        </h2>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="form-group col-md-4">
                                <label for="marketingConsent">Marketing Consent: </label>
                                <div class="form-inline">
                                    <p-toggleswitch formControlName="marketingConsent"
                                                    id="marketingConsent"></p-toggleswitch>
                                    <h4 class="margin-toggle">{{ marketingConsentLabel() }}</h4>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>

        <pre [hidden]="!isDeveloperMode()"><code>{{ getAllErrors(form) | json }}</code></pre>
        <div class="card-footer">
            <div class="row">
                <div class="col-md-12 text-center">
                    <button (click)="submit()" [disabled]="isLoading()" class="navy-btn btn-margin-bottom">
                        Save <i [hidden]="!isLoading()" class="fa fa-spinner fa-spin"></i>
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>
<ngx-ui-loader></ngx-ui-loader>

<!-- OAuth Credentials Modal -->
<p-dialog [(visible)]="showOAuthModal"
          [draggable]="false"
          [modal]="true"
          [resizable]="false"
          [style]="{width: '450px'}"
          header="OAuth Credentials">
    @if (oAuthCredentials) {
        <div class="p-fluid">
            <div class="p-field">
                <label for="clientId">Client ID:</label>
                <div class="d-flex">
                    <input [value]="oAuthCredentials.clientId" class="form-control" id="clientId" readonly type="text"/>
                    <button (click)="copyToClipboard(oAuthCredentials.clientId, 'clientId')"
                            class="navy-btn ml-2"
                            type="button">
                        @if (copiedFields['clientId']) {
                            Copied
                        } @else {
                            <i class="pi pi-copy"></i>
                        }
                    </button>
                </div>
            </div>
            <div class="p-field mt-3">
                <label for="clientSecret">Client Secret:</label>
                <div class="d-flex">
                    <input [value]="oAuthCredentials.clientSecret"
                           class="form-control"
                           id="clientSecret"
                           readonly
                           type="text"/>
                    <button (click)="copyToClipboard(oAuthCredentials.clientSecret, 'clientSecret')"
                            class="navy-btn ml-2"
                            type="button">
                        @if (copiedFields['clientSecret']) {
                            Copied
                        } @else {
                            <i class="pi pi-copy"></i>
                        }
                    </button>
                </div>
            </div>
            <div class="alert alert-warning mt-3">
                <i class="fas fa-exclamation-triangle"></i> Please save these credentials now. Once you close this
                popup, we cannot provide the client secret again.
            </div>
        </div>
    }
    <ng-template pTemplate="footer">
        <button (click)="showOAuthModal = false" class="navy-btn" type="button">Close</button>
    </ng-template>
</p-dialog>

<!-- Sits below the Bootstrap modal layer so the regenerate and disable confirmations open on top of it. -->
<p-dialog (onHide)="closeStoreKeys()"
          [baseZIndex]="-100"
          [draggable]="false"
          [modal]="true"
          [resizable]="false"
          [style]="{width: '560px'}"
          [visible]="!!keysDialogStore"
          header="Store Keys"
          styleClass="ecommerce-keys-dialog">
    @let keysStore = keysDialogStore;
    @if (keysStore) {
        <div class="ecommerce-keys-store">
            <div>
                <div class="ecommerce-store-domain">{{ keysStore.domain || '-' }}</div>
                <div class="ecommerce-store-type">{{ keysStore.eCommerceStoreName }}</div>
            </div>
            @if (keysStore.active) {
                <span class="ecommerce-pill ecommerce-pill--success"><span class="ecommerce-pill-dot"></span>Active</span>
            } @else {
                <span class="ecommerce-pill ecommerce-pill--neutral"><span class="ecommerce-pill-dot"></span>Inactive</span>
            }
        </div>

        <div class="ecommerce-key-label" id="storePublicKeyLabel">Public Key</div>
        <div class="ecommerce-key-row">
            <code aria-labelledby="storePublicKeyLabel" class="ecommerce-key-value" id="storePublicKey">
                @if (isPublicKeyVisible(keysStore.id)) {
                    {{ keysStore.publicKey || '-' }}
                } @else {
                    {{ keysStore.publicKey ? (keysStore.publicKey | slice:0:20) + '...' : '-' }}
                }
            </code>
            <button (click)="togglePublicKeyVisibility(keysStore.id)"
                    [attr.aria-label]="isPublicKeyVisible(keysStore.id) ? 'Hide public key' : 'Show public key'"
                    [disabled]="!keysStore.publicKey"
                    [pTooltip]="isPublicKeyVisible(keysStore.id) ? 'Hide public key' : 'Show full public key'"
                    class="ecommerce-key-icon-btn"
                    type="button">
                <i [class]="isPublicKeyVisible(keysStore.id) ? 'fa fa-eye-slash' : 'fa fa-eye'"></i>
            </button>
            <button (click)="copyToClipboard(keysStore.publicKey, 'storePublicKey')"
                    aria-label="Copy public key"
                    [disabled]="!keysStore.publicKey"
                    [pTooltip]="copiedFields['storePublicKey'] ? 'Copied!' : 'Copy public key'"
                    class="ecommerce-key-icon-btn"
                    type="button">
                <i [class]="copiedFields['storePublicKey'] ? 'fa fa-check' : 'fa fa-copy'"></i>
            </button>
        </div>

        <div class="ecommerce-key-label" id="storeSecretKeyLabel">Secret Key</div>
        <div class="ecommerce-key-row">
            <code aria-labelledby="storeSecretKeyLabel" class="ecommerce-key-value" id="storeSecretKey">
                @if (isSecretVisible(keysStore.id)) {
                    {{ keysStore.secretKey || '-' }}
                } @else {
                    ••••••••••••••••
                }
            </code>
            <button (click)="toggleSecretVisibility(keysStore.id)"
                    [attr.aria-label]="isSecretVisible(keysStore.id) ? 'Hide secret' : 'Show secret'"
                    [disabled]="!keysStore.secretKey"
                    [pTooltip]="isSecretVisible(keysStore.id) ? 'Hide secret' : 'Show secret'"
                    class="ecommerce-key-icon-btn"
                    type="button">
                <i [class]="isSecretVisible(keysStore.id) ? 'fa fa-eye-slash' : 'fa fa-eye'"></i>
            </button>
            <button (click)="copyToClipboard(keysStore.secretKey, 'storeSecretKey')"
                    aria-label="Copy secret key"
                    [disabled]="!keysStore.secretKey"
                    [pTooltip]="copiedFields['storeSecretKey'] ? 'Copied!' : 'Copy secret key'"
                    class="ecommerce-key-icon-btn"
                    type="button">
                <i [class]="copiedFields['storeSecretKey'] ? 'fa fa-check' : 'fa fa-copy'"></i>
            </button>
        </div>
        <span aria-live="polite" class="sr-only">
            @if (copiedFields['storePublicKey']) {
                Public key copied
            } @else if (copiedFields['storeSecretKey']) {
                Secret key copied
            }
        </span>
    }
    <ng-template pTemplate="footer">
        @let footerStore = keysDialogStore;
        @if (footerStore) {
            <div class="ecommerce-keys-footer">
                <button (click)="regenerateECommerceStoreKeys(footerStore)"
                        [disabled]="isRegenerating(footerStore.id)"
                        class="navy-btn"
                        type="button">
                    Regenerate Keys
                    <i [hidden]="!isRegenerating(footerStore.id)" class="fa fa-spinner fa-spin"></i>
                </button>
                @if (footerStore.active) {
                    <button (click)="onDisableBusinessECommerceStore(footerStore)"
                            class="orange-btn"
                            type="button">
                        Disable Store
                    </button>
                }
                <button (click)="closeStoreKeys()" class="navy-btn ecommerce-keys-close" type="button">Close</button>
            </div>
        }
    </ng-template>
</p-dialog>
